import Splide from "@splidejs/splide";

class BannerSlider {
    constructor() {
        this.slider = document.querySelector(".banner-slider");

        if (this.slider) {
            this.initSlider();
        }
    }

    initSlider() {
        const splide = new Splide(this.slider, {
            pagination: false,
        });

        splide.on("move", function (data) {
            document.querySelector(".banner-slider__current").innerHTML =
                "0" + (parseInt(data) + 1);
        });

        splide.mount();
    }
}

export default BannerSlider;
